<template>
  <div>
    <div id="bar100p" :style="setHeight.height">
      <svg
        :height="setHeight.height"
        version="1.1"
        width="100%"
        xmlns="http://www.w3.org/2000/svg"
        xmlns:xlink="http://www.w3.org/1999/xlink"
        style="font-family:'IPA Pゴシック'; overflow: hidden; position: relative;"
      >
        <g class="scale">
          <line
            v-for="n of 11"
            class="scale-line"
            x1="7%"
            :y1="setMemoryY(n-1)"
            :x2="setMemoryX2"
            :y2="setMemoryY(n-1)"
            stroke="#eee"
            :key="`first-${n}`"
          />
          <text
            v-for="(item,num) in items"
            :x="setMemoryX"
            :y="setItemNameY(num)"
            font-size="10"
            stroke="black"
            text-anchor="start"
            stroke-width="0.5"
            :key="num"
          >
            <tspan>{{item.name}}</tspan>
            <tspan :x="setMemoryX" dy="15">{{item.name2}}</tspan>
          </text>
          <rect
            v-for="(val,num) in len"
            class="itemcolor"
            :x="setMemoryX"
            :y="setItemNameY(num)"
            :width="10"
            :height="10"
            :fill="setColor(num)"
            :key="`ic-${num}`"
          />
          <text
            v-for="n of 11"
            x="5"
            :y="setMemoryY(n-1)"
            font-size="8"
            stroke="black"
            text-anchor="start"
            stroke-width="0.5"
            :key="`sec-${n}`"
          >{{(n-1) *10}}%</text>
          <g>
            <text
              :x="setLabelX(1)"
              :y="setLabelY"
              font-size="8"
              stroke="black"
              text-anchor="middle"
              stroke-width="0.5"
            >全業界</text>
            <text
              id="jobtext"
              :x="setLabelX(2)"
              :y="setLabelY"
              font-size="8"
              stroke="black"
              text-anchor="middle"
              stroke-width="0.5"
            >{{jobName}}</text>
          </g>
        </g>
        <g class="chart">
          <g class="bar">
            <rect
              v-for="(val,num) in len"
              class="bar-item"
              :x="graphLeft+'%'"
              :y="setGraphY(num,1)"
              :width="setGraphW"
              :height="setGraphH(val)"
              :fill="setColor(num)"
              :key="`bar1-${num}`"
            />
          </g>
          <g class="bar">
            <rect
              v-for="(val,num) in len2"
              class="bar-item"
              :x="setGraphX(2)"
              :y="setGraphY(num,2)"
              :width="setGraphW"
              :height="setGraphH(val)"
              :fill="setColor(num)"
              :key="`bar2-${num}`"
            />
          </g>
          <line
            v-for="(val,num) in len"
            class="bar-line"
            :x1="setBarLineX(1)"
            :y1="setBarLineY(num,1)"
            :x2="setBarLineX(2)"
            :y2="setBarLineY(num,2)"
            stroke="#777"
            :key="`barline-${num}`"
          />
          <!-- <animateTransform
            attributeName="transform"
            attributeType="XML"
            type="scale"
            dur="0.5s"
            repeatCount="0"
            values="1,0; 1,1"
          /> -->
        </g>
      </svg>
    </div>
  </div>
</template>

<script>
export default {
  props: ["graphData","jobName"],
  data() {
    return {
      barHeight: 300,
      topPadding: 50,
      bottomPadding: 50,
      graphLeft: 10,
      graphWidth: 20,
      graphDistance: 10,
      jobTextWidth: 0,
      items: [
        { num: 1, name: "スペシャリスト志向" },
        { num: 2, name: "マネージャー志向" },
        { num: 3, name: "自立行動志向" },
        { num: 4, name: "安定志向" },
        { num: 5, name: "企業家志向" },
        { num: 6, name: "社会貢献志向" },
        { num: 7, name: "チャレンジャー志向" },
        { num: 8, name: "ライフワーク",name2: "バランス志向" },
      ],
      len: [
        { num: 1, val: 8 },
        { num: 2, val: 15 },
        { num: 3, val: 10 },
        { num: 4, val: 17 },
        { num: 5, val: 7 },
        { num: 6, val: 11 },
        { num: 7, val: 17 },
        { num: 8, val: 15 },
      ],
      len2: this.graphData,

      colors: {
        1: "#004ca5",
        2: "#15b8d3",
        3: "#0b847b",
        4: "#a3c2c0",
        5: "#1788dd",
        6: "#00aa9f",
        7: "#235fd9",
        8: "#0000d4",
      }
    };
  },
  // mounted: function () {
  //   let test =  document.getElementById('jobtext').getBBox();
  //   console.log(test);
  // },  
  computed: {
    setHeight() {
      return {
        height: this.barHeight + this.topPadding + this.bottomPadding,
      };
    },
    setMemoryY() {
      return function (data) {
        return this.barHeight - this.barHeight * (data / 10) + this.topPadding;
      };
    },
    setItemNameY() {
      return function (data) {
        return (
          this.barHeight - this.barHeight * (data / 8) + this.topPadding - 10
        );
      };
    },
    setGraphH() {
      return function (data) {
        return this.barHeight * (data.val / 100);
      };
    },
    setMemoryX2() {
      return (
        this.graphLeft + (this.graphWidth + this.graphDistance) * 2 - 5 + "%"
      );
    },
    setMemoryX() {
      return (
        this.graphLeft + (this.graphWidth + this.graphDistance) * 2 - 3 + "%"
      );
    },
    setGraphX() {
      return function (num) {
        let x;
        if (num === 2) {
          x = this.graphLeft + this.graphDistance + this.graphWidth;
        } else {
          x = this.graphLeft;
        }
        return x + "%";
      };
    },
    setGraphW() {
      return this.graphWidth + "%";
    },
    setGraphY() {
      return function (num, bar) {
        let leg = 0;
        let i = 0;
        if (bar === 1) {
          for (i = 0; i <= num; i++) {
            leg += this.len[i].val;
          }
        } else {
          for (i = 0; i <= num; i++) {
            leg += this.len2[i].val;
          }
        }
        return this.barHeight - this.barHeight * (leg / 100) + this.topPadding;
      };
    },
    setLabelX() {
      return function (val) {

        if (val == 2) {
          return (
            this.graphLeft +
            this.graphDistance +
            this.graphWidth +
            this.graphWidth / 2 +
            "%"
          );
        } else {
          return this.graphLeft + this.graphWidth / 2 + "%";
        }
      };
    },
    setLabelY() {
      return this.barHeight + this.topPadding + 15;
    },
    setColor() {
      return function (val) {
        return this.colors[val + 1];
      };
    },
    setBarLineX() {
      return function (bar) {
        let x;
        if (bar === 1) {
          x = this.graphLeft + this.graphWidth;
        } else {
          x = this.graphLeft + this.graphWidth + this.graphDistance;
        }
        return x + "%";
      };
    },
    setBarLineY() {
      return function (num, bar) {
        let leg = 0;
        let i = 0;
        if (bar === 1) {
          for (i = 0; i <= num; i++) {
            leg += this.len[i].val;
          }
        } else {
          for (i = 0; i <= num; i++) {
            leg += this.len2[i].val;
          }
        }
        return this.barHeight - this.barHeight * (leg / 100) + this.topPadding;
      };
    },
  },
};
</script>

<style lang="scss" scoped>
#bar100p {
  width: 100%;
  // max-width: 500px;
  box-sizing: border-box;
  background-color: #fff;
  padding: 0 5px;

  transform-origin: center bottom;
  animation: anim 0.5s linear 0s;
  animation-fill-mode: forwards;    

}
.chart {
  /* transform: scaleY(0.5); */
  transform-origin: 0 500px;
  // cursor: pointer;
}
// .bar-item:hover{
//   box-shadow: 1px 1px 1px 0 rgba(0,0,0,0.5);
//   opacity: .5;
// }
.itemcolor {
  transform: translateX(-12px) translateY(-9px);
}

@keyframes anim {
  0%{
    transform: scaleY(0);
  }
  100%{
    transform: scaleY(1);
  }
}
</style>